module.exports = __webpack_public_path__ + "static/media/ZT.8315ba34.pdf";